import { AlertTriangle, Clock } from "lucide-react";
import { useLeaderGateStatus } from "@/hooks/useLeaderGate";

/**
 * Banner shown in LeaderLayout when the leader's coach hasn't upgraded
 * and this leader is in the gated set.
 * - Soft gate (1-7 days): warning with countdown
 * - Hard gate (0 days): blocked message
 */
export function LeaderGracePeriodBanner() {
  const gateStatus = useLeaderGateStatus();

  if (gateStatus.isLoading || !gateStatus.isGated) return null;

  if (gateStatus.isHardGated) {
    return (
      <div className="border-b border-destructive/30 bg-destructive/5 px-4 py-3 flex items-center gap-3">
        <AlertTriangle className="h-5 w-5 text-destructive shrink-0" />
        <p className="text-sm text-foreground">
          <span className="font-medium">Access paused.</span>{" "}
          Your coach's plan has reached its leader limit. Ask your coach to upgrade to restore full access.
        </p>
      </div>
    );
  }

  return (
    <div className="border-b border-muted bg-muted/30 px-4 py-3 flex items-center gap-3">
      <Clock className="h-5 w-5 text-muted-foreground shrink-0" />
      <p className="text-sm text-muted-foreground">
        <span className="font-medium text-foreground">
          {gateStatus.graceDaysLeft} day{gateStatus.graceDaysLeft !== 1 ? "s" : ""} remaining.
        </span>{" "}
        Your coach's plan is at capacity. Ask your coach to upgrade to continue access after the grace period.
      </p>
    </div>
  );
}
